// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__35FM9","validationTips":"StatementDescriptor_validationTips__3a4_j"};